import { createContext, useContext, ReactNode } from 'react';
import { AllowedMenu } from './AuthContext';

interface CurrentMenuContextType {
  currentMenu: AllowedMenu | null;
}

const CurrentMenuContext = createContext<CurrentMenuContextType | undefined>(undefined);

export const useCurrentMenu = () => {
  const context = useContext(CurrentMenuContext);
  if (context === undefined) {
    return { currentMenu: null };
  }
  return context;
};

interface CurrentMenuProviderProps {
  children: ReactNode;
  menu: AllowedMenu | null;
}

export const CurrentMenuProvider = ({ children, menu }: CurrentMenuProviderProps) => {
  return (
    <CurrentMenuContext.Provider value={{ currentMenu: menu }}>
      {children}
    </CurrentMenuContext.Provider>
  );
};
